import { Eye } from 'lucide-react';
import styled from 'styled-components';

import { IconButton } from '../../../components/atoms/icon-button/icon-button';
import { Aviso } from '../../../types/aviso';
import { AvisoStatusBadge } from './aviso-status-badge';
import { AvisoTipoBadge } from './aviso-tipo-badge';
import { formatDate, formatDateTime } from './format';

interface Props {
  items: Aviso[];
  onOpen: (id: string) => void;
}

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  overflow: hidden;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};

  thead th {
    text-align: left;
    padding: 12px 16px;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${({ theme }) => theme.colors.textMuted};
    background: ${({ theme }) => theme.colors.bgMuted};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    font-weight: 600;
  }

  tbody td {
    padding: 12px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.colors.bgMuted};
  }

  th:last-child,
  td:last-child {
    text-align: right;
  }
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.3;

  strong {
    font-weight: 600;
  }
  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
  }
`;

export const AvisosTable = ({ items, onOpen }: Props) => (
  <Table>
    <thead>
      <tr>
        <th scope="col">Título</th>
        <th scope="col">Tipo</th>
        <th scope="col">Status</th>
        <th scope="col">Início</th>
        <th scope="col">Expira</th>
        <th scope="col">Atualizado</th>
        <th scope="col">Ações</th>
      </tr>
    </thead>
    <tbody>
      {items.map((a) => (
        <tr key={a.id} data-testid={`aviso-row-${a.id}`}>
          <td>
            <Title>
              <strong>{a.titulo}</strong>
              <small>#{a.id.slice(0, 8)}</small>
            </Title>
          </td>
          <td>
            <AvisoTipoBadge tipo={a.tipo} />
          </td>
          <td>
            <AvisoStatusBadge status={a.status} />
          </td>
          <td>{formatDate(a.dataInicio)}</td>
          <td>{formatDate(a.dataExpiracao)}</td>
          <td>{formatDateTime(a.updatedAt)}</td>
          <td>
            <IconButton
              label={`Ver detalhes de ${a.titulo}`}
              onClick={() => onOpen(a.id)}
            >
              <Eye size={16} />
            </IconButton>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);
